export default {
  supportsIntegratedFind: false,
  setStateWaitTime: 200,
  scale: {
    defaultScaleValue: 'auto',
    defaultScale: 1.0,
    defaultScaleDelta: 1.1,
    minScale: 0.25,
    maxScale: 2.5,
    unknownScale: 9,
    maxAutoScale: 1.25,
  },
};
